import { AllowedHttpMethods, employeeListConfig } from '../../apiList'
import {
  EmployeeListApiProps,
  EmploymentStatus,
  GetEmployeeResponse,
  updateHierarchyReportingManagerProps,
} from '../../../../types/EmployeeDirectory/EmployeesList/employeeListTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'

const getEmployees = async (
  props: EmployeeListApiProps,
): Promise<GetEmployeeResponse> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeListConfig.getEmployeeList,
    method: AllowedHttpMethods.get,
    params: {
      endIndex: props.endIndex ?? 20,
      startIndex: props.startIndex ?? 0,
      searchStr: props.searchStr ?? '',
      selectionStatus: props.selectionStatus ?? EmploymentStatus.active,
      selectionDate: props.selectionDate,
      from: props.from,
      to: props.to,
      country: props.country,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const updateReportee = async (
  updateHierarchyReportingManager: updateHierarchyReportingManagerProps,
): Promise<number | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeListConfig.updateHierarchyReportingManager,
    method: AllowedHttpMethods.put,
    params: updateHierarchyReportingManager,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const exportEmployeeData = async (
  props: EmployeeListApiProps,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: employeeListConfig.exportEmployeeData,
    method: AllowedHttpMethods.get,
    params: {
      searchStr: props.searchStr ?? '',
      selectionStatus: props.selectionStatus ?? EmploymentStatus.active,
      token: localStorage.getItem('token') ?? '',
      tenantKey: localStorage.getItem('token') ?? '',
      country: props.country ?? '',
      from: props.from,
      to: props.to,
      selectionDate: props.selectionDate,
    },
    responseType: 'blob',
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const employeeListApi = {
  getEmployees,
  exportEmployeeData,
  updateReportee,
}

export default employeeListApi
